import React, { useContext } from 'react';
import { BrowserHistoryContext } from '../utils/router/BrowserHistoryContext';

/**
 * Create Context Consumer HOC for `browserHistory`, reads React router browser history instance
 * from context and pass it to children via props.
 * Should be used along long with Components which children of `<StatefulMemoryRouter/>`.
 *
 * @returns {function(*): function(*=, *): *}
 */
export const withBrowserHistory = () => (Component) => {
  const BrowserHistoryConsumer = (props) => {
    const context = useContext(BrowserHistoryContext);

    return <Component {...props} browserHistory={context} />;
  };

  BrowserHistoryConsumer.displayName = `BrowserHistoryConsumer(${Component.displayName || Component.name})`;

  return BrowserHistoryConsumer;
};

export default withBrowserHistory;
